import $http from '@/core/services/http.service';
import { ActionTree } from 'vuex';

import { State } from '@/manager/employee/store/state';
import Endpoints from '@/constants/endpoints';

export const actions: ActionTree<State, any> = {
    fetchEmployeeList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            const params: any = {};
            if ( payload && payload.limit > -1 ) {
                params.limit = payload.limit;
            }
            if (payload && payload.search) {
                params.search = payload.search;
            }
            $http.get(`${Endpoints.employee}`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('setEmployeeList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },


};
